import React from 'react';
import { useHistory } from 'react-router-dom';
import './CustomerTabs.scss';

interface ICustomerTabs{
  Tabs?:any;
  replace?: boolean;
}
const CustomerTabs = ({ Tabs, replace = false }:ICustomerTabs) => {
  const { push, location, replace: pushReplace } = useHistory();
  const { pathname } = location;
  const navigate = replace ? pushReplace : push;
  return (
    <div className="admin-merchant-cover">

      <div className="admin-merchant-inner-cover">
        {
          Tabs?.map((list) => (
            <p
              className={pathname === list?.link ? 'admin-active-tab' : 'admin-tab-link'}
              key={list?.id}
              onClick={() => {
                if (list?.disabled) return;
                navigate(list?.link);
              }}
              style={{
                opacity: list?.disabled ? 0.5 : 1,
                cursor: list?.disabled ? 'not-allowed' : 'pointer',
              }}
            >
              {list?.name}
              {' '}
              {list?.count && pathname === list?.link ? <span>{list?.count}</span> : ''}
            </p>
          ))
        }
      </div>

    </div>
  );
};
export default CustomerTabs;
